// ./Pages/BlogPost/BlogPost.js
import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { getPostId } from "../../WebApi";
import { useParams } from "react-router-dom";

const PostContainer = styled.div`
    width: 80%;
    margin: 0 auto;
  `;
const PostTitle = styled.div`
  text-align: center;
  font-size: 24px;
`;
const PostBody = styled.div``;


export default function BlogPost() {
  let { slug } = useParams();

  const [ post, setPost ] = useState({
    title: "",
    body: "" 
  });


  useEffect(() => {
    getPostId(slug).then( post => {
      if (post.length > 0) {
        setPost(post[0]);
      }
    });
  }, [slug]);

  return (
    <PostContainer>
      <PostTitle>{post.title}</PostTitle>
      <PostBody>{post.body}</PostBody>
    </PostContainer>
  );
}


